import { render, staticRenderFns } from "./LegalDocumentContent_zVSVLW.vue?vue&type=template&id=4d4b0e5e&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_zVSVLW.vue?vue&type=style&index=0&id=4d4b0e5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4b0e5e",
  null
  
)

export default component.exports